import React from 'react';
import { Loader2, Save, X } from 'lucide-react';

export interface ManualNoteFormProps {
  manualDate: string;
  setManualDate: (v: string) => void;
  manualTitle: string;
  setManualTitle: (v: string) => void;
  manualContent: string;
  setManualContent: (v: string) => void;
  manualSaving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export function ManualNoteForm({
  manualDate, setManualDate,
  manualTitle, setManualTitle,
  manualContent, setManualContent,
  manualSaving,
  onSave, onCancel,
}: ManualNoteFormProps) {
  return (
    <div className="mb-8 bg-white rounded-lg shadow-sm border-l-4 border-l-amber-400 border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">Manual Note</h2>
        <button onClick={onCancel} className="text-gray-400 hover:text-gray-600">
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
            <input type="date" value={manualDate} onChange={e => setManualDate(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Title *</label>
            <input value={manualTitle} onChange={e => setManualTitle(e.target.value)}
              placeholder="e.g. Phone call, Result received, Admin note"
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" autoFocus />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Content *</label>
          <textarea value={manualContent} onChange={e => setManualContent(e.target.value)}
            placeholder="Note content..."
            rows={6}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
      </div>
      <div className="flex items-center gap-3 mt-4">
        <button onClick={onSave} disabled={manualSaving || !manualTitle || !manualContent}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 flex items-center gap-2">
          {manualSaving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
          Save Note
        </button>
        <button onClick={onCancel} className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800">
          Cancel
        </button>
      </div>
    </div>
  );
}
